import { IPublicClientApplication } from '@azure/msal-browser';
import { ProgramDocumentQueries } from '../../models/queries-type';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createProgramDocumentDownloadTicket, getProgramDocuments } from './index';

export const createProgramDocumentsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getProgramDocuments: (instance: IPublicClientApplication, programDocumentQueries: ProgramDocumentQueries) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getProgramDocuments(fetchContext, programDocumentQueries, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getProgramDocuments', isInFlight);
    },
  ),
  createProgramDocumentDownloadTicket: (instance: IPublicClientApplication, programDocumentId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createProgramDocumentDownloadTicket(fetchContext, programDocumentId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createProgramDocumentDownloadTicket', isInFlight);
    },
  ),
});
